export default __webpack_public_path__ + "img/compromisoetico-icon.6532de27.png";